import React, { useEffect, useState, Component } from 'react';

import Switch from '@material-ui/core/Switch';
import { Link, useHistory } from 'react-router-dom';
import FirebaseService from '../../services/firebase';
import './style.css';
import { Grid, Typography } from '@material-ui/core';

const Header = (props) => {
    const history = useHistory();
    const [account, setAccount] = useState(null);
    React.useEffect(() => {
        // window.addEventListener("dblclick", listener);
    }, []);




    const updateAccount = (snapshot) => {
        if (!account && snapshot.data()) {
            setAccount(snapshot.data());
        }
    }

    const handleChange = (event) => {
        console.log(event.target.checked, account)
        account.status = event.target.checked ? 'online' : 'offline';
        setAccount(account);
        FirebaseService.updateAccount(account);
    }

    const logout = () => {

        FirebaseService.logout().then(() => history.push("/login"));
    }

    FirebaseService.subscribeAccount(updateAccount);

    return (
        <div className="header-container">
            <div className="header-group">
                <Link to="/dashboard">
                    <button className="btn">Dashboard</button>
                </Link>
                <Link to="/chat">
                    <button className="btn">Chat</button>
                </Link>
            </div>

            <div className="header-group">
                <div className="user-container">
                    <p>Usuer: {account?.email}</p>
                    <Typography component="div">
                        <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>Off-line</Grid>
                            <Grid item>
                                <Switch
                                    checked={account?.status == 'online'}
                                    onChange={handleChange}
                                    name="status"
                                    color="primary"
                                />
                            </Grid>
                            <Grid item>On-line</Grid>
                        </Grid>
                    </Typography>
                </div>

                <button className="btn btn-logout" onClick={logout}>Logout</button>
            </div>

        </div>
    )
}

export default Header;